<template>
    <v-dialog v-model="dialog" scrollable persistent max-width="670px" transition="dialog-transition">
        <template v-slot:activator="{ on }">
            <v-btn color="#0B3F67" dark v-on="on">
                Agregar
                <v-icon right>mdi-plus-box-outline</v-icon>
            </v-btn>
        </template>
        <v-card :loading="loading">
            <v-card-title class="pa-0">
              <ModalTitle titulo="Agrear Historial" @cancelar="cancelar"/>
            </v-card-title>  
            <v-divider></v-divider>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <div class="d-flex flex-row align-center">
                            <div class="d-flex mr-3">
                                Instalaci&oacute;n
                            </div>
                            <v-text-field 
                                v-model="instalacion"
                                disabled
                                required>
                            </v-text-field>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="d-flex flex-row align-center">
                            <div class="d-flex mr-3">
                                Año
                            </div>
                            <v-text-field 
                                v-model="estrellaMod.anio"
                                :error-messages="anioErrors"
                                @change="$v.estrellaMod.anio.$touch()"
                                @blur="$v.estrellaMod.anio.$touch()"
                                required>
                            </v-text-field>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="d-flex flex-row align-center">
                            <div class="d-flex mr-3">
                                Nota
                            </div>
                            <v-text-field 
                                v-model="estrellaMod.nota"
                                required>
                            </v-text-field>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="d-flex flex-row align-center">
                            <div class="d-flex mr-3">
                                Estrellas Blancas
                            </div>
                            <v-text-field 
                                v-model="estrellaMod.cantidadEstrellasBlancas"
                                required>
                            </v-text-field>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="d-flex flex-row align-center">
                            <div class="d-flex mr-3">
                                Estrella Verde
                            </div>
                            <v-checkbox
                                v-model="estrellaMod.estrellaVerdeBol"
                                color="#0B3F67">                    
                            </v-checkbox>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="d-flex flex-row align-center">
                            <div class="d-flex mr-3">
                                Estrella Plateada
                            </div>
                            <v-checkbox
                                v-model="estrellaMod.estrellaPlateadaBol"
                                color="#0B3F67">                    
                            </v-checkbox>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="d-flex flex-row align-center">
                            <div class="d-flex mr-3">
                                Estrella Anaranjada
                            </div>
                            <v-checkbox
                                v-model="estrellaMod.estrellaAnaranjadaBol"
                                color="#0B3F67">                    
                            </v-checkbox>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="d-flex flex-row align-center">
                            <div class="d-flex mr-3">
                                Inscrita sin informe
                            </div>
                            <v-checkbox
                                v-model="estrellaMod.inscritaBol"
                                color="#0B3F67">                    
                            </v-checkbox>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text :disabled="loading" color="error" @click="cancelar">Cancelar</v-btn>
                <v-btn text :loading="loading" color="#0B3F67" @click="cargaManual">Modificar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from "@/axios"
import { required } from "vuelidate/lib/validators";
import ModalTitle from '@/components/utils/ModalTitleComponent'

export default {
    created() {
        axios.defaults.headers.common["Authorization"] = "Bearer " + this.$store.getters.token;
    },
    components: {
      ModalTitle
    },
    props: [
        'idInstalacion',
        'instalacion'
    ],
    computed: {
        anioErrors () {
            const errors = []
            if (!this.$v.estrellaMod.anio.$dirty) return errors            
            !this.$v.estrellaMod.anio.required && errors.push('El año es requerido.')     
            return errors
        },
    },
    data: () => ({
        dialog: false,
        loading: false,
        estrellaMod: {
            id: 0,
            nota: '',
            cantidadEstrellasBlancas: '',
            estrellaVerde: '',
            estrellaAnaranjada: '',
            estrellaPlateada: '',
            inscrita: '',
            instalacion: '',
            anio: '',
            estrellaVerdeBol: false,
            estrellaAnaranjadaBol: false,
            estrellaPlateadaBol: false,
            inscritaBol: false,
        }
    }),
      validations: {
        estrellaMod: {
            anio: {
                required,               
            }
        }
    },
    methods: {
        cancelar() {
            this.dialog = false;
            this.loading = false;
        },
        cargaManual() {
            this.$v.$touch();
            if(!this.$v.$invalid) {
                this.loading = true;
                axios.post("/instalaciones/cargaManualEstrellas/", this.estrellaMod, { params: {
                    id: this.idInstalacion
                }}).then(() => {
                    this.$emit("recargaTabla");
                    this.$store.dispatch('noti',{mensaje: 'Carga manual realizada', color:'success'});   
                    this.cancelar();
                }).catch(error => {
                  this.$store.dispatch('loadingPage', false);
                        this.$store.dispatch("noti", {
                            mensaje: "Ocurrió un error al hacer la carga manual",
                            color: "error"
                        });
                        console.log(error);
                        this.loading = false;
                })
            }
        }
    }
};
</script>
